import { Notifications } from "@orbital/games-frontend-library"
import floorFigure from "../configs/floorFigure"
import { sendStakes } from "../../settings/useSettings"

export const footerStateHandler = (
  state: number,
  betClicked: boolean,
  betForNextRound: boolean,
  setBetForNextRound: (b: boolean) => void,
  setBetClicked: (b: boolean) => void,
  setDisabledBlock: (b: boolean) => void,
  setFooterState: (s: string) => void,
  auto: any,
  handleAutoInputs: any,
  footerState: any,
  place: string,
  handleNotification: any,
  placedBet: any,
  userCashouted: any,
  setUserCashouted: any,
  isJackpot: boolean,
) => {
  const autoPlay = place === "first" ? auto.first : auto.second
  const placeIndex = place === "first" ? "0" : "1"
  const showAuto = autoPlay.showAuto
  let newCount = 0
  if (isJackpot) {
    setFooterState("bet")
    setBetClicked(false)
    setBetForNextRound(false)
    setDisabledBlock(false)
    // setUserCashouted(false)
    return
  }

  switch (state) {
    case 1:
      if (betClicked || betForNextRound) {
        setBetForNextRound(false)
        setDisabledBlock(true)
        if (betForNextRound) {
          setBetClicked(true)
        } else if (placedBet.index === placeIndex) {
          setBetClicked(true)
        }
        return showAuto ? setFooterState("stop") : setFooterState("cancel")
      }
      return showAuto ? setFooterState("start auto") : setFooterState("bet")
    case 2:
      setDisabledBlock(false)
      if (betClicked) {
        newCount = userCashouted ? autoPlay.betCount : autoPlay.betCount + 1
        showAuto && handleAutoInputs(place, "betCount", newCount)
        setDisabledBlock(true)
        if (placedBet.error && placedBet.error.code !== 0) {
          setFooterState("bet")
          setBetClicked(false)
          setBetForNextRound(false)
          setDisabledBlock(false)
        } else if (placedBet.index === placeIndex) {
          setFooterState("cashout")
          setDisabledBlock(false)
        }
        if (userCashouted && !showAuto) {
          setBetClicked(false)
          setFooterState("bet")
        }
        if (userCashouted && showAuto) {
          setFooterState("stop")
          setBetClicked(false)
          setBetForNextRound(true)
          autoPlayHandler(
            // showAuto,
            autoPlay.numberOfBets,
            setBetForNextRound,
            autoPlay.betsLeft,
            handleNotification,
          )
        }
        return
      } else if (betForNextRound) {
        return showAuto ? setFooterState("stop") : setFooterState("cancel")
      }
      return showAuto ? setFooterState("start auto") : setFooterState("bet")
    case 3:
      setUserCashouted(false)
      setDisabledBlock(false)
      if (autoPlay.betCount >= Number(autoPlay.numberOfBets)) {
        newCount = 0
        showAuto && handleAutoInputs(place, "betCount", newCount)
      }
      // აქ showAuto როცა არ წერია ავტოს დარსულების შემდეგ მანუალზეც ავტო
      footerState === "cashout" &&
        showAuto &&
        autoPlayHandler(
          // showAuto,
          autoPlay.numberOfBets,
          setBetForNextRound,
          autoPlay.betsLeft,
          handleNotification,
        )
      setBetClicked(false)
      if (betForNextRound) {
        // setDisabledBlock(true)
        return showAuto ? setFooterState("stop") : setFooterState("cancel")
      }

      return showAuto ? setFooterState("start auto") : setFooterState("bet")
  }
}

export const handleBet = (
  place: string,
  state: number,
  betClicked: boolean,
  betForNextRound: boolean,
  setBetForNextRound: any,
  setBetClicked: any,
  handleAutoInputs: any,
) => {
  // state === 2 &&  handleAutoInputs(place, "betCount", 0)
  if (state === 2 || state === 3) {
    handleAutoInputs(place, "betCount", 0)
    setBetForNextRound(true)
  } else {
    setBetClicked(true)
  }
  if (((state === 2 || state === 3) && betForNextRound) || betClicked) {
    setBetForNextRound(false)
    setBetClicked(false) // როცა რესფონსი აგვიანებს და ქენსელი ჩანს
  }
}

export const cashoutHandler = (
  stellarSocketMessages: any,
  setBetClicked: any,
  setBetForNextRound: any,
  place: string,
  auto: any,
) => {
  setBetClicked(false)
  auto.showAuto &&
    autoPlayHandler(
      // auto.showAuto,
      auto.numberOfBets,
      setBetForNextRound,
      auto.betsLeft,
    )
  stellarSocketMessages.cashout(place === "first" ? 0 : 1)
}
const autoPlayHandler = (
  // showAuto: boolean,
  numberOfBets: any,
  nextRound: any,
  betsLeft: number,
  handleNotification?: any,
) => {
  if (numberOfBets === "0") {
    nextRound(true)
  } else if (numberOfBets > 0 && betsLeft > 0) {
    nextRound(true)
  } else {
    nextRound(false)
    handleNotification &&
      handleNotification(Notifications.onSelectedNumberOfBets)
  }
}
export const refreshHandler = (placedBet: any, setBet: any) => {
  if (placedBet.state === 1 && placedBet.bet > 0) {
    setBet(true)
  }
}

export const cashoutValueHandler = (
  roundUpdateValue: any,
  stakeValue: any,
  prec: any,
) => {
  let value = (+(Number(roundUpdateValue) * Number(stakeValue))).toString()
  value = floorFigure(value, prec)
  return value
}

export const placeBet = (
  stellarSocketMessages: any,
  stakes: any,
  index: number,
  cashoutAt: number,
  audio: any,
) => {
  sendStakes(stakes, audio)
  stellarSocketMessages.placeBet(stakes, index, cashoutAt)
}

export const getJackpot = (stellarSocketMessages: any) => {
  stellarSocketMessages.getJackpot()
}
